export const environment = {
  production: true,
  env: 'prod',
  analyticsConfiguration: {},
  webhookBackendUrl: 'https://ilp-webhooks-api.chep.com',
  backendDedicatedFMUrl: 'https://ilp-fm-api.chep.com',
  backendUrl: 'https://ilp-api.chep.com',
  serviceDeskUrl: 'https://contact.cmaweb.chep.com',
  sentryEnabled: true,
  auth0: {
    domain: 'https://cmaprod.eu.auth0.com',
    clientId: 'QtJ6vrZ31cgDFdVwXH9cjdmlx7KTTBxs',
    audience: 'https://cma-api-prd.azurewebsites.net',
    cacheLocation: 'localstorage'
  },
  features: {
    geotracking: true,
    notificationsToDrivers: true,
    hotspotTracking: true,
    logEvents: true,
    tnxDashboard: true,
  },
  firebaseConfig: {
    env: 'prod',
    apiKey: 'AIzaSyDdoOHRyJOcyF3cH9DsAHOHhfMrfwJJVNw',
    authDomain: 'chep-cma.firebaseapp.com',
    databaseURL: 'https://chep-cma.firebaseio.com',
    projectId: 'chep-cma',
    storageBucket: 'chep-cma.appspot.com',
    messagingSenderId: '757406627801'
  },
  agmConfig: {
    apiKey: 'AIzaSyDdoOHRyJOcyF3cH9DsAHOHhfMrfwJJVNw'
  }
};
